import * as React from "react";
import { useV9RibbonIconPreviewGalleryEnabled } from "../../RibbonGallery/Galleries/hooks/useNextRibbonIconPreviewGalleryEnabled";
import { RibbonIconPreviewGallery as RibbonIconPreviewGalleryNext } from "./next/RibbonIconPreviewGallery";
import RibbonIconPreviewGalleryCurrent from "./RibbonIconPreviewGalleryCurrent";
import type {
  AppIconGalleryButtonProps,
  AppIconPreviewGalleryProps,
} from "@1js/acui-gallery-icon";
import type { RibbonControlInternalProps } from "../../RibbonControlProps";
import type { AppPreviewGalleryInternalProps } from "@1js/acui-gallery";

declare let __Delay_FluentV8__: boolean;

const V8RibbonIconPreviewGallery =
  typeof __Delay_FluentV8__ === "undefined" || !__Delay_FluentV8__
    ? RibbonIconPreviewGalleryCurrent
    : React.lazy(
        () =>
          import(
            /*webpackChunkName: "commonV8"*/ "./RibbonIconPreviewGalleryCurrent"
          )
      );

export type RibbonIconPreviewGalleryInternalProps = AppIconPreviewGalleryProps &
  AppPreviewGalleryInternalProps<AppIconGalleryButtonProps> &
  RibbonControlInternalProps;

export const RibbonIconPreviewGallery = React.forwardRef<
  HTMLDivElement,
  RibbonIconPreviewGalleryInternalProps
>((props, ref) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isNewPreviewGalleryEnabled = useV9RibbonIconPreviewGalleryEnabled();
  return isNewPreviewGalleryEnabled ? (
    <RibbonIconPreviewGalleryNext {...(props as any)} ref={ref as any} />
  ) : (
    <React.Suspense fallback={<></>}>
      <V8RibbonIconPreviewGallery {...props} ref={ref as any} />
    </React.Suspense>
  );
});
